import React, { useEffect, useRef, useState } from 'react';
import { ArrowRightIcon, StarIcon } from 'lucide-react';
const webinarHref = 'https://info.stresslessdogs.nl/webinar-mc-adv2';
function Stars() {
  return <div className="flex gap-0.5 text-[#c9653d]" aria-label="5 van de 5 sterren" data-id="element-4532" data-mp="3e3g5vk7fo5l6">
      {Array.from({
      length: 5
    }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-4533" data-mp="3j2sti764pgot" />)}
    </div>;
}
function InlineCta() {
  return <aside className="my-12 rounded-2xl border border-[#e7bda9] bg-[#fff7f2] p-6 text-center shadow-sm" data-id="element-4534" data-mp="akeendapk7er">
      <h3 className="font-serif text-2xl font-bold text-[#39251d]" data-id="element-4535" data-mp="1ljae6r857e3">
        Benieuwd wat jouw hond je vertelt?
      </h3>
      <p className="mt-3 text-lg leading-relaxed text-[#5c453b]" data-id="element-4536" data-mp="5mla0op1zlgl">
        Kijk het gratis webinar Communiceren met je hond.
      </p>
      <a href={webinarHref} className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#c9653d] px-5 py-3.5 font-bold text-white shadow-[0_4px_12px_rgba(135,70,41,0.22)] transition-colors hover:bg-[#ae5230] focus:outline-none focus:ring-4 focus:ring-[#f1c7b5]" data-id="element-4537" data-mp="2ma723gxn0g8p">
        Bekijk het gratis webinar
        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-4538" data-mp="3aw2v0t3hg4fq" />
      </a>
      <p className="mt-3 text-sm text-[#73564a]" data-id="element-4539" data-mp="3atym1wqq8f8l">Gratis · Online · Direct te bekijken</p>
    </aside>;
}
function VijfRedenenCommunicerenAdv6KortContent() {
  const inlineCtaRef = useRef<HTMLDivElement>(null);
  const [showStickyCta, setShowStickyCta] = useState(false);
  useEffect(() => {
    const updateStickyCta = () => {
      const cta = inlineCtaRef.current;
      if (!cta) return;
      setShowStickyCta(cta.getBoundingClientRect().bottom < 0);
    };
    updateStickyCta();
    window.addEventListener('scroll', updateStickyCta, {
      passive: true
    });
    window.addEventListener('resize', updateStickyCta);
    return () => {
      window.removeEventListener('scroll', updateStickyCta);
      window.removeEventListener('resize', updateStickyCta);
    };
  }, []);
  return <div className="min-h-screen bg-white pb-20 text-[#262321] md:pb-0" data-id="element-4540" data-mp="2w9smots77wl7">
      <header className="border-b border-stone-200" data-id="element-4541" data-mp="316iyv60vu81c">
        <div className="mx-auto flex max-w-[680px] items-center justify-between px-5 py-4" data-id="element-4542" data-mp="314y6nn21j16n">
          <span className="font-serif text-base font-bold tracking-tight text-[#342d29]" data-id="element-4543" data-mp="356t7yrjz1ekf">
            Stressless Dogs
          </span>
          <span className="text-xs text-stone-400" data-id="element-4544" data-mp="3ez8odkfmdv37">Advertorial</span>
        </div>
      </header>

      <main data-id="element-4545" data-mp="3jxaj52meriui">
        <article className="mx-auto max-w-[680px] px-5 pb-14 pt-10 md:pt-14" data-id="element-4546" data-mp="3jx0r79hsz1m6">
          <header className="border-b border-stone-200 pb-8" data-id="element-4547" data-mp="3ox6e6cd4nzxx">
            <p className="mb-4 text-sm font-bold uppercase tracking-[0.14em] text-[#b45734]" data-id="element-4548" data-mp="3ousiq2ejclpu">
              Honden &amp; Gedrag
            </p>
            <h1 className="font-serif text-[2.1rem] font-bold leading-[1.08] tracking-[-0.025em] text-[#201d1b] md:text-5xl" data-id="element-4549" data-mp="1ujdqney1ya6x">
              Waarom ruim 100.000 Nederlandse hondenbaasjes stoppen met corrigeren
              (en ervoor kiezen om hondentaal te leren)
            </h1>
            <p className="mt-5 text-xl font-medium leading-relaxed text-stone-600 md:text-2xl" data-id="element-4550" data-mp="1ma7y8xewzfdy">
              5 redenen waarom liefdevolle baasjes overstappen
            </p>
            <div className="mt-7 flex items-center gap-3 text-sm text-stone-500" data-id="element-4551" data-mp="1h928n8gjw88n">
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#e8c9b9] font-serif font-bold text-[#8a4b32]" aria-hidden="true" data-id="element-4552" data-mp="1db4edr7xavye">
                S
              </div>
              <div data-id="element-4553" data-mp="20z49t4g6jajb">
                <p className="font-medium text-stone-700" data-id="element-4554" data-mp="20ycmegwqkj44">Door de redactie van Stressless Dogs</p>
                <p data-id="element-4555" data-mp="1w0kmp0punspd">12 juni 2026 · Leestijd: 3 minuten</p>
              </div>
            </div>
          </header>

          <figure className="my-8 overflow-hidden rounded-2xl bg-stone-100" data-id="element-4556" data-mp="pl0dhrm4dab3">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/1aa86ec3-846d-4f2d-a96b-6be412601c19.jpg" alt="Baasje communiceert met hond" className="h-auto w-full" data-id="element-4557" data-mp="kkcplet6t9l3" />
          </figure>

          <div className="space-y-6 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4558" data-mp="2d9ljpwbbq432">
            <p data-id="element-4559" data-mp="1ziqgazjlgf6v">
              Je hond is superlief. Echt waar. En toch blaft hij de hele boel bij
              elkaar, trekt hij aan de lijn of valt hij 'uit het niets' uit.
            </p>
            <p data-id="element-4560" data-mp="2r8l60xbd66w2">
              Je hebt vast al van alles geprobeerd. Strenger zijn. 'Nee!' roepen.
              Corrigeren, zoals iedereen zegt dat je moet doen.
            </p>
            <p data-id="element-4561" data-mp="2i6bvw8k0cfj7">En toch wordt het niet beter. Sterker nog: vaak wordt het erger.</p>
            <p data-id="element-4562" data-mp="2n5yj9atjvc5q">
              Daar is een reden voor. En die reden verklaart waarom ruim 100.000
              Nederlandse hondenbaasjes het inmiddels anders doen. Zij leren geen
              commando's, maar hondentaal. Dit is waarom:
            </p>
          </div>

          <section className="mt-14" data-id="element-4563" data-mp="1boyjxv8sbx27">
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-[-0.015em] text-[#25211f] md:text-4xl" data-id="element-4564" data-mp="139j0z8uxtiqj">
              1. Je hond praat de hele dag tegen je. Jij hebt het alleen nooit leren verstaan.
            </h2>
            <p className="mt-5 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4565" data-mp="1d7yl2rvjrrqj">
              Zoals een cursist het zei: 'Ons hondje heeft voor mij nog een Chinese
              handleiding.' Honden communiceren continu met hun lichaam. Wie die
              taal leert lezen, ziet spanning aankomen voordat het misgaat. Geen
              verrassingen meer 'uit het niets'.
            </p>
          </section>

          <section className="mt-14" data-id="element-4566" data-mp="ubp8ya47hb96">
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-[-0.015em] text-[#25211f] md:text-4xl" data-id="element-4567" data-mp="pidwntgmk29v">
              2. Omdat 'af!' roepen nog nooit een hond stiller heeft gemaakt.
            </h2>
            <p className="mt-5 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4568" data-mp="3syl1w4eou7kr">
              Blaffen, trekken en uitvallen zijn geen ongehoorzaamheid. Het zijn
              boodschappen. Corrigeren onderdrukt hooguit het signaal, maar de
              emotie eronder blijft. Daarom komt het gedrag altijd terug, of komt
              er iets anders voor in de plaats. Wie de boodschap begrijpt, kan
              eindelijk bij de oorzaak beginnen.
            </p>
            <div ref={inlineCtaRef} data-id="element-4569" data-mp="1dxvk1d960ko0">
              <InlineCta data-id="element-4570" data-mp="1dyx8qkj3t5o7" />
            </div>
          </section>

          <section className="mt-14" data-id="element-4571" data-mp="1iwf6rfvl20hf">
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-[-0.015em] text-[#25211f] md:text-4xl" data-id="element-4572" data-mp="1ixhzltcguczz">
              3. Wat eruitziet als stoer gedrag, is bijna altijd angst.
            </h2>
            <p className="mt-5 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4573" data-mp="1ryy8txrjo92m">
              Duizenden baasjes ontdekten dat hun 'agressieve' hond eigenlijk een
              onzekere hond in een stoer lichaam is. Dat verandert alles. Want een
              bange hond straf je niet, die help je. En nee, je hond troosten
              versterkt de angst niet. Dat is een hardnekkige mythe.
            </p>
            <blockquote className="my-9 border-l-4 border-[#c9653d] pl-5 font-serif text-2xl italic leading-snug text-[#624334] md:text-3xl" data-id="element-4574" data-mp="38jgz7ba9xczh">
              “Een onzekere hond in een stoer lichaam. Dat verandert alles.”
            </blockquote>
          </section>

          <section className="mt-14" data-id="element-4575" data-mp="2ur0orpf1mcoj">
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-[-0.015em] text-[#25211f] md:text-4xl" data-id="element-4576" data-mp="2unwfweqmusrj">
              4. Rust aan beide kanten van de lijn.
            </h2>
            <p className="mt-5 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4577" data-mp="2ks35b0wh59ce">
              'Wandelen is vooral stress in plaats van ontspanning,' schreef een
              baasje. Herkenbaar? Jouw spanning loopt via de lijn rechtstreeks
              naar je hond, en andersom. Baasjes die hun hond leren lezen, merken
              dat ze zelf ook ontspannen. De wandeling wordt weer waar je hem voor
              nam: samen genieten.
            </p>
            <figure className="my-8 overflow-hidden rounded-2xl bg-stone-100" data-id="element-4578" data-mp="129g8qtpy12pq">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/9240b968-cbf1-4f2f-ba2c-d8c18510d8e0.jpg" alt="Ontspannen wandelen met je hond" className="h-auto w-full" data-id="element-4579" data-mp="oi1oyko7oxhm" />
            </figure>
          </section>

          <section className="mt-14" data-id="element-4580" data-mp="jigmw1dqw90o">
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-[-0.015em] text-[#25211f] md:text-4xl" data-id="element-4581" data-mp="jjhyq82l4zjg">
              5. Voor de band die je altijd al wilde.
            </h2>
            <p className="mt-5 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4582" data-mp="aj1yd7h528it">
              Of je nu een puppy hebt, een adoptiehond met een rugzakje, of een
              trouwe metgezel van acht jaar: begrijpen schept vertrouwen. En als
              je bij een vorige hond dingen anders had willen doen: dat was geen
              onwil, dat was liefde zonder de juiste kennis. Die kennis bestaat nu
              wel.
            </p>
          </section>
        </article>

        <section className="mx-auto max-w-[680px] px-5 py-14" data-id="element-4583" data-mp="2nstojs15atfo">
          <h2 className="font-serif text-3xl font-bold leading-tight text-[#25211f] md:text-4xl" data-id="element-4584" data-mp="2nu4qrnexzt4o">
            Waar begin je?
          </h2>
          <div className="mt-5 space-y-6 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4585" data-mp="2xpol45duyjrb">
            <p data-id="element-4586" data-mp="2srwkmmz5dpbi">
              Hondentaal leren is de basis. Niet de totaaloplossing voor elk
              probleem, wel de eerste stap waar elke gedragsverandering mee begint.
              Zonder begrip is elke training gokken.
            </p>
            <p data-id="element-4587" data-mp="32qc7uev20efq">
              Daarom geeft Stressless Dogs het gratis online webinar Communiceren
              met je hond: daarin leer je stap voor stap wat je hond je vertelt,
              zonder corrigeren, zonder straffen, zonder onzin over 'dominantie'.
            </p>
            <p data-id="element-4588" data-mp="31sm5z6oipcwl">Ruim 100.000 hondenbaasjes gingen je voor.</p>
          </div>

          <section id="webinar" className="mt-10 rounded-3xl bg-[#f8e1d4] p-7 text-center shadow-[0_10px_25px_rgba(93,57,39,0.1)] md:p-10" aria-labelledby="webinar-heading" data-id="element-4589" data-mp="2xpzkdnifwo7u">
            <p className="text-xs font-bold tracking-[0.16em] text-[#a04b2d]" data-id="element-4590" data-mp="2ntcziyq45x5t">
              GRATIS ONLINE WEBINAR
            </p>
            <h2 id="webinar-heading" className="mt-3 font-serif text-3xl font-bold text-[#33231d] md:text-4xl" data-id="element-4591" data-mp="3lhwhs9l57dpf">
              Communiceren met je hond
            </h2>
            <p className="mx-auto mt-4 max-w-md text-lg leading-relaxed text-[#5e463b]" data-id="element-4592" data-mp="3bopgp0xfqjv5">
              Ontdek wat jouw hond je al die tijd probeerde te vertellen.
            </p>
            <a href={webinarHref} className="mt-7 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#c9653d] px-6 py-4 text-lg font-bold text-white shadow-[0_4px_12px_rgba(135,70,41,0.22)] transition-colors hover:bg-[#ae5230] focus:outline-none focus:ring-4 focus:ring-[#f1c7b5]" data-id="element-4593" data-mp="816zbmq0sq5l">
              Ja, ik kijk het gratis webinar
              <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-4594" data-mp="kizyjrg8qksa" />
            </a>
            <p className="mt-3 text-sm text-[#73564a]" data-id="element-4595" data-mp="pim7hop1deva">Gratis · Online · Direct te bekijken</p>
          </section>

          <section className="mt-12 -mx-5 bg-stone-100 px-5 py-10" aria-labelledby="testimonials-heading" data-id="element-4596" data-mp="tkr48was6rm5">
            <div className="mx-auto max-w-[760px]" data-id="element-4597" data-mp="yiirhd0hdpk0">
              <h2 id="testimonials-heading" className="mb-6 text-center font-serif text-2xl font-bold text-[#282321]" data-id="element-4598" data-mp="yh7srrlw77zr">
                Wat baasjes zeggen
              </h2>
              <div className="grid gap-4 md:grid-cols-3" data-id="element-4599" data-mp="1d86sed4r2m77">
                <figure className="rounded-2xl bg-white p-5 shadow-sm" data-id="element-4600" data-mp="1d9rnc3uz875l">
                  <Stars data-id="element-4601" data-mp="1hats107nxbey" />
                  <blockquote className="mt-3 text-base leading-relaxed text-stone-700" data-id="element-4602" data-mp="1ha1v9m2bx7n3">
                    “Eindelijk begrijp ik wat ze me al die tijd probeerde te vertellen.”
                  </blockquote>
                  <figcaption className="mt-4 text-sm font-bold text-stone-900" data-id="element-4603" data-mp="3998lmlgk031f">
                    Annemiek &amp; Luna
                  </figcaption>
                </figure>
                <figure className="rounded-2xl bg-white p-5 shadow-sm" data-id="element-4604" data-mp="3ib86jouovr9n">
                  <Stars data-id="element-4605" data-mp="uqkz4sxzpru" />
                  <blockquote className="mt-3 text-base leading-relaxed text-stone-700" data-id="element-4606" data-mp="tynfofsbhyx">
                    “Onze wandelingen zijn nu ontspannen in plaats van stress.”
                  </blockquote>
                  <figcaption className="mt-4 text-sm font-bold text-stone-900" data-id="element-4607" data-mp="9vodoqxxkav4">
                    Peter &amp; Max
                  </figcaption>
                </figure>
                <figure className="rounded-2xl bg-white p-5 shadow-sm" data-id="element-4608" data-mp="2bmt5bmzv5bfg">
                  <Stars data-id="element-4609" data-mp="27lziyy22k4oo" />
                  <blockquote className="mt-3 text-base leading-relaxed text-stone-700" data-id="element-4610" data-mp="27mrey9zkw4fh">
                    “Ik zie nu signalen die ik vijf jaar lang heb gemist.”
                  </blockquote>
                  <figcaption className="mt-4 text-sm font-bold text-stone-900" data-id="element-4611" data-mp="21jw5cj44o3cw">
                    Sandra &amp; Boef
                  </figcaption>
                </figure>
              </div>
            </div>
          </section>
        </section>
      </main>

      <footer className="border-t border-stone-200 px-5 py-9 text-center text-sm text-stone-500" data-id="element-4612" data-mp="1sozn712fjgcw">
        <p className="font-serif font-bold text-stone-700" data-id="element-4613" data-mp="1dwemxe6r6hml">Stressless Dogs</p>
        <div className="mt-3 flex justify-center gap-4" data-id="element-4614" data-mp="1iug4tvsg0awh">
          <a href="#privacy" className="underline hover:text-stone-800" data-id="element-4615" data-mp="14u5ceobhio97">Privacybeleid</a>
          <a href="#voorwaarden" className="underline hover:text-stone-800" data-id="element-4616" data-mp="19ryh1cx53a7d">Algemene voorwaarden</a>
        </div>
        <p className="mt-4" data-id="element-4617" data-mp="2z74zt3m3wmr1">Dit artikel wordt je aangeboden door Stressless Dogs.</p>
      </footer>

      {showStickyCta && <div className="fixed inset-x-0 bottom-0 z-50 border-t border-[#e8c7b7] bg-white/95 p-3 shadow-[0_-5px_18px_rgba(47,34,27,0.12)] backdrop-blur md:hidden" data-id="element-4618" data-mp="345zf3vkv7t6e">
          <a href={webinarHref} className="flex w-full items-center justify-center rounded-xl bg-[#c9653d] px-5 py-3.5 font-bold text-white shadow-sm" data-id="element-4619" data-mp="z4n6p6cggiog">
            Bekijk het gratis webinar
          </a>
        </div>}
    </div>;
}
export function VijfRedenenCommunicerenAdv6KortPage() {
  return <VijfRedenenCommunicerenAdv6KortContent data-id="element-4620" data-mp="l6ymm0q7pfkg" />;
}